export default __webpack_public_path__ + "pattern-triangle.png?f8b0ea4a7f488137d6500c9ff232b8f4";